/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */
/* eslint-disable max-len */

/* La newsletter automatique des clients ( Fred, 21/10/2026 ) : activee et mise en
   place depuis la Console. */
export default {
    NEWSLETTERS_title: "Newsletter automatique",
    NEWSLETTERS_blogsTitle: "Blogs du client",
    NEWSLETTERS_tabNewsletters: "Newsletters",
    NEWSLETTERS_tabBlogs: "Blogs",
    NEWSLETTERS_blogsHelp: "Les flux RSS du compte et leurs articles, réglés comme dans le logiciel du client (Blogs RSS).",
    NEWSLETTERS_blogsEmpty: "Ce client n'a pas encore de blog.",
    NEWSLETTERS_blogsBack: "Tous les blogs",
    NEWSLETTERS_blogDelete: "Supprimer",
    NEWSLETTERS_blogDeleteStep1: "Attention : supprimer le blog « {name} » supprime aussi ses {count} articles, avec leurs réglages newsletter. Rien ne pourra être restauré.",
    NEWSLETTERS_blogDeleteStep1All: "Attention : supprimer le blog « {name} » supprime aussi tous ses articles, avec leurs réglages newsletter. Rien ne pourra être restauré.",
    NEWSLETTERS_blogDeleteContinue: "Continuer",
    NEWSLETTERS_blogDeleteStep2: "Dernière confirmation : le blog « {name} » et ses articles vont être supprimés définitivement.",
    NEWSLETTERS_blogDeleteFinal: "Supprimer définitivement",
    NEWSLETTERS_blogDeleted: "Blog supprimé, avec ses articles.",
    NEWSLETTERS_editEmail: "Modifier l'e-mail",
    NEWSLETTERS_emailPending: "La modification de l'e-mail depuis la Console arrive avec la prochaine version de l'API.",
    NEWSLETTERS_emailTitle: "E-mail de la newsletter",
    NEWSLETTERS_emailHeading: "E-mail — {name}",
    NEWSLETTERS_emailBack: "Statistiques",
    NEWSLETTERS_emailSave: "Enregistrer",
    NEWSLETTERS_emailQuit: "Quitter",
    NEWSLETTERS_emailSaved: "E-mail enregistré.",
    NEWSLETTERS_emailSavedNoBlock: "E-mail enregistré. Il ne contient aucun bloc rempli à l'envoi (articles, annonces, annonces vendues) : la newsletter ne peut pas être activée.",
    NEWSLETTERS_emailQuitUnsaved: "L'e-mail a des modifications non enregistrées.",
    NEWSLETTERS_emailQuitWithoutSaving: "Quitter sans enregistrer",
    NEWSLETTERS_emailUndo: "Annuler",
    NEWSLETTERS_emailRedo: "Rétablir",
    NEWSLETTERS_emailImages: "Choisir une image",
    NEWSLETTERS_emailImagesPending: "La médiathèque du client n'a pas pu être lue.",
    NEWSLETTERS_mediaTitle:
        "Gestionnaire de médias",
    NEWSLETTERS_mediaClose:
        "Fermer",
    NEWSLETTERS_mediaAll:
        "Toutes les images",
    NEWSLETTERS_mediaSearch:
        "Rechercher par nom de média",
    NEWSLETTERS_mediaDropHint:
        "Glisser vos images ici ou cliquez sur <u>ajouter</u>. Format JPG, PNG, GIF, WebP 20 Mo max.",
    NEWSLETTERS_mediaUploading:
        "Envoi en cours…",
    NEWSLETTERS_mediaInvalidFormat:
        "Format non pris en charge. Formats acceptés : JPG, PNG, GIF, WebP.",
    NEWSLETTERS_mediaTooLarge:
        "Fichier trop volumineux. Taille maximale : 20 Mo.",
    NEWSLETTERS_mediaUploadFailed:
        "L'image n'a pas pu être ajoutée.",
    NEWSLETTERS_mediaRenameFailed:
        "L'image n'a pas pu être renommée.",
    NEWSLETTERS_mediaNoResults:
        "Nous n'avons trouvé aucun résultat correspondant à votre recherche.",
    NEWSLETTERS_mediaEmpty:
        "Aucune image",
    NEWSLETTERS_mediaSelect:
        "Sélectionner l'image",
    NEWSLETTERS_mediaRename:
        "Cliquer pour renommer",
    NEWSLETTERS_emailImageUrl: "Adresse de l'image",
    NEWSLETTERS_emailImageUse: "Utiliser cette image",
    NEWSLETTERS_blogAdd: "Ajouter un blog",
    NEWSLETTERS_blogNew: "Nouveau blog",
    NEWSLETTERS_blogCreate: "Créer le blog",
    NEWSLETTERS_blogCancel: "Annuler",
    NEWSLETTERS_blogCreated: "Blog créé : les articles du flux sont en cours d'import.",
    NEWSLETTERS_blogCreateHelp: "Le blog est créé au nom du propriétaire du compte, comme s'il l'avait ajouté dans Blogs RSS.",
    NEWSLETTERS_blogImporting: "Import des articles en cours…",
    NEWSLETTERS_blogFieldsMissing: "Renseignez le nom, l'adresse du flux et la date d'import.",
    NEWSLETTERS_blogInfo: "Informations générales",
    NEWSLETTERS_blogName: "Nom du blog",
    NEWSLETTERS_blogFeed: "Flux RSS du blog",
    NEWSLETTERS_blogStatus: "Statut",
    NEWSLETTERS_blogTracking: "Suivi du blog",
    NEWSLETTERS_blogTrackingHelp: "À poser une fois sur le blog, dans son pied de page : il sert à tous les articles.",
    NEWSLETTERS_blogCtaScript: "Script des appels à l'action",
    NEWSLETTERS_blogCtaScriptHelp: "Son adresse se lit dans le compte du client (Blogs RSS → paramètres du blog) ; la Console l'affichera dès que l'API la lui rend.",
    NEWSLETTERS_blogVisitsScript: "Script de suivi des visites",
    NEWSLETTERS_blogVisitsHelp: "Comptera les visites de chaque article et les lecteurs uniques. Disponible prochainement.",
    NEWSLETTERS_blogSoon: "Bientôt",
    NEWSLETTERS_blogPreview: "Aperçu du blog",
    NEWSLETTERS_blogOpen: "Ouvrir le blog",
    NEWSLETTERS_blogExtract: "Extrait du flux RSS",
    NEWSLETTERS_blogStartDate: "Importer les articles à partir de",
    NEWSLETTERS_blogUpdate: "Mettre à jour",
    NEWSLETTERS_blogValidateUrl: "Valider l'URL",
    NEWSLETTERS_blogUpdated: "Blog mis à jour : le flux est relu.",
    NEWSLETTERS_blogArchive: "Archiver",
    NEWSLETTERS_blogPublish: "Publier",
    NEWSLETTERS_blogArchived: "Blog archivé.",
    NEWSLETTERS_blogPublished: "Blog publié.",
    NEWSLETTERS_blogWritePending: "La modification des blogs depuis la Console arrive avec la prochaine version de l'API.",
    NEWSLETTERS_blogCopy: "Copier",
    NEWSLETTERS_blogCopied: "Copié",
    NEWSLETTERS_blogCtaScriptUse: "À coller une fois dans le pied de page du blog (WordPress : bloc « HTML personnalisé » ou extension d'insertion de code).",
    NEWSLETTERS_blogColAuthor: "Auteur",
    NEWSLETTERS_blogColExtract: "Extrait de l'article",
    NEWSLETTERS_blogColTitle: "Titre",
    NEWSLETTERS_blogColUrl: "Url",
    NEWSLETTERS_blogColPublished: "Publié le",
    NEWSLETTERS_blogColNewsletter: "Newsletter",
    NEWSLETTERS_blogActive: "Actif",
    NEWSLETTERS_blogInactive: "Inactif",
    NEWSLETTERS_blogImportedAt: "Dernière lecture du flux",
    NEWSLETTERS_blogNoPost: "Aucun article.",
    NEWSLETTERS_blogPostDraft: "Brouillon",
    NEWSLETTERS_blogPostExcluded: "Exclu de la newsletter",
    NEWSLETTERS_blogPostTargeted: "Ciblé",
    NEWSLETTERS_help: "Activez l'offre pour un client et réglez ses newsletters, sans passer par son compte. L'e-mail se construit dans le PB e-mail du client.",
    NEWSLETTERS_customer: "Client",
    NEWSLETTERS_customerPlaceholder: "Société, nom ou e-mail",
    NEWSLETTERS_noCustomer: "Aucun client trouvé.",
    NEWSLETTERS_back: "Choisir un autre client",
    NEWSLETTERS_group: "Groupe {id}",
    NEWSLETTERS_loading: "Chargement…",

    NEWSLETTERS_offer: "Offre « Newsletter automatique »",
    NEWSLETTERS_offerOnHelp: "Activée : le client voit l'écran complet dans son logiciel, et les newsletters actives partent à leur heure.",
    NEWSLETTERS_offerOffHelp: "Désactivée : le client voit la présentation de l'offre, aucun envoi ne part. Le réglage est conservé.",
    NEWSLETTERS_offerOn: "L'offre est activée pour ce client.",
    NEWSLETTERS_offerOff: "L'offre est désactivée. Les envois s'arrêtent, le réglage est conservé.",
    NEWSLETTERS_offerOffWarning: "L'offre est désactivée : cette newsletter ne part pas tant qu'elle n'est pas réactivée.",

    NEWSLETTERS_list: "Newsletters du client",
    NEWSLETTERS_create: "Créer une newsletter",
    NEWSLETTERS_empty: "Aucune newsletter pour ce client.",
    NEWSLETTERS_frequency: "Rythme",
    NEWSLETTERS_nextSend: "Prochain envoi",
    NEWSLETTERS_paused: "En pause",
    NEWSLETTERS_sender: "Expéditeur",
    NEWSLETTERS_noSender: "Aucun",
    NEWSLETTERS_noDynamicBlock: "L'e-mail ne contient aucun bloc rempli à l'envoi (articles, annonces ou annonces vendues) : la newsletter ne peut pas être activée. Le client l'ajoute dans son PB e-mail.",
    NEWSLETTERS_noSenderWarning: "Sans adresse d'expéditeur, la newsletter ne part pas.",
    NEWSLETTERS_updated: "Modifiée le {date} par {who}",
    NEWSLETTERS_byConsole: "l'équipe Facilogi",
    NEWSLETTERS_byCustomer: "le client",
    NEWSLETTERS_settings: "Régler",
    NEWSLETTERS_testAndPreview: "Essai et aperçu",
    NEWSLETTERS_statistics: "Statistiques",
    NEWSLETTERS_delete: "Supprimer",
    NEWSLETTERS_deleteConfirm: "Supprimer la newsletter « {name} » et son e-mail ? Cette action est définitive.",
    NEWSLETTERS_deleted: "La newsletter est supprimée.",
    NEWSLETTERS_saved: "La newsletter est enregistrée.",

    NEWSLETTERS_createTitle: "Créer une newsletter",
    NEWSLETTERS_editTitle: "Régler la newsletter",
    NEWSLETTERS_save: "Enregistrer",
    NEWSLETTERS_emailNote: "L'e-mail de la newsletter (articles, annonces, mise en page) se construit dans le PB e-mail du client. Ici : tout le reste.",
    NEWSLETTERS_sectionGeneral: "Général",
    NEWSLETTERS_sectionFrequency: "Rythme",
    NEWSLETTERS_sectionRecipients: "Destinataires",
    NEWSLETTERS_fieldName: "Libellé",
    NEWSLETTERS_nameRequired: "Le libellé est obligatoire.",
    NEWSLETTERS_fieldSubject: "Sujet",
    NEWSLETTERS_fieldSubjectHelp: "Le sujet peut reprendre des informations du contact : choisissez-les dans « Variables ».",
    NEWSLETTERS_fieldSenderName: "Nom de l'expéditeur",
    NEWSLETTERS_fieldSenderEmail: "Adresse de l'expéditeur",
    NEWSLETTERS_senderRequired: "Obligatoire pour que la newsletter parte.",
    NEWSLETTERS_domainNotValid: "Ce domaine n'est pas authentifié pour ce client : l'expéditeur par défaut partira à la place de cette adresse.",
    NEWSLETTERS_fieldReplyTo: "Adresse de réponse",
    NEWSLETTERS_sameReply: "Utiliser le même e-mail pour la réponse",
    NEWSLETTERS_kindWeekly: "Chaque semaine, le",
    NEWSLETTERS_kindMonthly: "Le premier du mois",
    NEWSLETTERS_everyWeeks: "toutes les (semaines)",
    NEWSLETTERS_everyMonths: "tous les (mois)",
    NEWSLETTERS_at: "à",
    NEWSLETTERS_fieldNextSend: "Prochain envoi",
    NEWSLETTERS_fieldNextSendHelp: "Date calculée d'après le rythme. Si vous la changez, seul ce prochain envoi est déplacé : les suivants gardent le rythme.",
    NEWSLETTERS_frequencyWeekly: "Le {day}, chaque semaine, à {time}",
    NEWSLETTERS_frequencyWeeklyN: "Le {day}, toutes les {every} semaines, à {time}",
    NEWSLETTERS_frequencyMonthly: "Le premier {day} du mois, à {time}",
    NEWSLETTERS_frequencyMonthlyN: "Le premier {day}, tous les {every} mois, à {time}",
    NEWSLETTERS_weekday1: "Lundi",
    NEWSLETTERS_weekday2: "Mardi",
    NEWSLETTERS_weekday3: "Mercredi",
    NEWSLETTERS_weekday4: "Jeudi",
    NEWSLETTERS_weekday5: "Vendredi",
    NEWSLETTERS_weekday6: "Samedi",
    NEWSLETTERS_weekday7: "Dimanche",

    NEWSLETTERS_allContacts: "Tous les contacts",
    NEWSLETTERS_roles: "Lien avec une propriété",
    NEWSLETTERS_role1: "Propriétaires",
    NEWSLETTERS_role2: "Locataires",
    NEWSLETTERS_role3: "Anciens propriétaires",
    NEWSLETTERS_role4: "Anciens locataires",
    NEWSLETTERS_searches: "Recherche en cours",
    NEWSLETTERS_active_buyers: "Acquéreurs actifs (achat)",
    NEWSLETTERS_active_renters: "Acquéreurs actifs (location)",
    NEWSLETTERS_owners_also_buyers: "Propriétaires qui ont aussi une recherche active",
    NEWSLETTERS_tagsIn: "Contacts portant les tags",
    NEWSLETTERS_addTag: "Ajouter un tag…",
    NEWSLETTERS_contacts: "Contacts choisis",
    NEWSLETTERS_exclude: "Ne pas envoyer à",
    NEWSLETTERS_excludeTag: "Exclure un tag…",
    NEWSLETTERS_addContact: "Ajouter un contact",
    NEWSLETTERS_excludeContact: "Exclure un contact",
    NEWSLETTERS_contactPlaceholder: "Nom, prénom ou e-mail",
    NEWSLETTERS_contactId: "Contact n° {id}",
    NEWSLETTERS_nobody: "Aucun critère : personne ne recevra la newsletter.",
    NEWSLETTERS_countTotal: "{total} contacts recevront la newsletter",
    NEWSLETTERS_countExcluded: "{excluded} écartés (sans adresse : {noEmail}, non autorisés : {notAuthorized}, adresses en échec : {bounced})",

    NEWSLETTERS_testTitle: "Essai et aperçu — {name}",
    NEWSLETTERS_sendTest: "Envoyer l'essai",
    NEWSLETTERS_referenceContact: "Voir comme le contact",
    NEWSLETTERS_removeContact: "Retirer",
    NEWSLETTERS_noContactHelp: "Sans contact choisi, l'essai ne contient que les articles ouverts à tous.",
    NEWSLETTERS_nextSendContent: "Au prochain envoi",
    NEWSLETTERS_previewSubject: "Sujet",
    NEWSLETTERS_previewSince: "Contenus publiés depuis : {date}",
    NEWSLETTERS_firstSend: "premier envoi, les plus récents",
    NEWSLETTERS_previewRecipients: "{recipients} destinataires, dont {withContent} avec au moins un contenu",
    NEWSLETTERS_nothingToSend:
        "Rien de neuf à envoyer : aucun nouvel article ni nouvelle annonce depuis le dernier envoi. Le prochain envoi ne partira pas, l'essai non plus.",
    NEWSLETTERS_nothingToSendNoEmail:
        "L'e-mail de la newsletter n'est pas encore créé. Créez-le avec « Modifier l'e-mail », avec au moins un bloc Articles ou Annonces : sans lui, rien ne part, ni l'essai ni le prochain envoi.",
    NEWSLETTERS_nothingToSendNoBlog:
        "Le bloc Articles de l'e-mail n'est relié à aucun blog. Ouvrez « Modifier l'e-mail » et choisissez le blog dans le bloc : sans lui, rien ne part, ni l'essai ni le prochain envoi.",
    NEWSLETTERS_articlesBlock: "Bloc Articles {index} ({total} au plus)",
    NEWSLETTERS_noArticle: "Aucun article.",
    NEWSLETTERS_previewListings: "{count} annonces dans les blocs d'annonces",
    NEWSLETTERS_listingsBlock: "Bloc d'annonces {index} : {count} annonce(s)",
    NEWSLETTERS_contactReceives: "Ce contact recevrait {count} articles.",
    NEWSLETTERS_forThisContact: "Pour ce contact",
    NEWSLETTERS_articlesTitle: "Articles : x{count}",
    NEWSLETTERS_articlesTitleIndexed: "Articles {index} : x{count}",
    NEWSLETTERS_listingsKind_sale: "Annonces en vente : x{count}",
    NEWSLETTERS_listingsKind_rental: "Annonces en location : x{count}",
    NEWSLETTERS_listingsKind_all: "Annonces : x{count}",
    NEWSLETTERS_listingsKind_sold: "Annonces vendues : x{count}",
    NEWSLETTERS_ruleFilter_LastPublished: "Les derniers articles publiés",
    NEWSLETTERS_ruleFilter_MostPopular: "Les articles les plus consultés",
    NEWSLETTERS_ruleFilter_TagBased: "Les articles en fonction des tags",
    NEWSLETTERS_ruleTags: "Tags de l'article : {names}",
    NEWSLETTERS_ruleNoTags: "Tags de l'article : aucun",
    NEWSLETTERS_ruleTotal: "Nombre d'articles : {count}",
    NEWSLETTERS_ruleListingsKind: "Annonces à afficher : {kind}",
    NEWSLETTERS_ruleListingsTotal: "Nombre d'annonces : {count}",
    NEWSLETTERS_ruleKind_sale: "Dernières ventes",
    NEWSLETTERS_ruleKind_rental: "Dernières locations",
    NEWSLETTERS_ruleKind_all: "Dernières ventes et locations",
    NEWSLETTERS_noContactFound: "Aucun contact trouvé pour « {keyword} ».",
    NEWSLETTERS_testEmail: "Email d'essai",
    NEWSLETTERS_testSent: "L'essai est parti vers {email}.",

    NEWSLETTERS_backToList: "Retour à la liste du client",
    NEWSLETTERS_eligible: "Contacts éligibles",
    NEWSLETTERS_eligibleOf: "sur {matched} contacts visés par les critères",
    NEWSLETTERS_excludedHead: "Écartés",
    NEWSLETTERS_excludedNoEmail: "Sans adresse e-mail",
    NEWSLETTERS_excludedNotAuthorized: "Consentement refusé (RGPD)",
    NEWSLETTERS_excludedBounced: "Adresses en échec",
    NEWSLETTERS_noDeliveryYet: "Aucun e-mail délivré pour l'instant.",
    NEWSLETTERS_openedEmails: "E-mails ouverts",
    NEWSLETTERS_openedOf: "sur {delivered} e-mails délivrés",
    NEWSLETTERS_demoBanner:
        "Données de démonstration : les contacts et les premiers articles sont ceux du client, complétés par des « Article d'exemple », les chiffres sont inventés pour travailler le design. Retirez ?demo=1 de l'adresse pour revenir aux vrais chiffres.",
    NEWSLETTERS_chartTitle: "Ouvertures et clics, envoi après envoi",
    NEWSLETTERS_miniRecipients: "destinataires, par envoi",
    NEWSLETTERS_miniDelivered: "délivrés, par envoi",
    NEWSLETTERS_miniOpened: "ouvertures, par envoi",
    NEWSLETTERS_miniClicked: "clics, par envoi",
    NEWSLETTERS_miniUnsubscribed: "désinscriptions, par envoi",
    NEWSLETTERS_recipientsToday: "{count} destinataires aujourd'hui",
    NEWSLETTERS_statsTitle: "Statistiques — {name}",
    NEWSLETTERS_from: "Du",
    NEWSLETTERS_to: "au",
    NEWSLETTERS_apply: "Appliquer",
    NEWSLETTERS_sendsDone: "Envois faits",
    NEWSLETTERS_sendsSkipped: "{count} envois sautés faute de contenu",
    NEWSLETTERS_emailsSent: "E-mails envoyés",
    NEWSLETTERS_deliveredBounced: "{delivered} délivrés, {bounced} rebonds",
    NEWSLETTERS_opens: "Ouvertures",
    NEWSLETTERS_uniqueUnder: "{count} uniques, sous-comptées",
    NEWSLETTERS_clicks: "Clics",
    NEWSLETTERS_uniqueCto: "{count} uniques, {cto} des ouvertures",
    NEWSLETTERS_unsubscribed: "Désinscriptions",
    NEWSLETTERS_spam: "{count} plaintes",
    NEWSLETTERS_lastTargeted: "Dernier envoi : {targeted} ciblés, {recipients} destinataires",
    NEWSLETTERS_opensWarning: "Les ouvertures passent par le pixel de suivi : elles sont sous-comptées. Les clics sont le chiffre fiable ; les articles cliqués arrivent le lendemain.",
    NEWSLETTERS_openRate: "Taux d'ouverture",
    NEWSLETTERS_clickRate: "Taux de clic",
    NEWSLETTERS_sends: "Historique des envois",
    NEWSLETTERS_noSend: "Aucun envoi pour l'instant.",
    NEWSLETTERS_colDate: "Date",
    NEWSLETTERS_colStatus: "État",
    NEWSLETTERS_colArticles: "Articles",
    NEWSLETTERS_colRecipients: "Destinataires",
    NEWSLETTERS_colDelivered: "Délivrés",
    NEWSLETTERS_colOpened: "Ouvertures",
    NEWSLETTERS_colClicked: "Clics",
    NEWSLETTERS_colUnsubscribed: "Désinscrits",
    NEWSLETTERS_sendPosts: "Articles de l'envoi",
    NEWSLETTERS_postLine: "{title} — reçu par {recipients}, {clicks} clics",
    NEWSLETTERS_sendContacts: "Contacts : articles reçus, ouverture, articles cliqués",
    NEWSLETTERS_opened: "Ouvert",
    NEWSLETTERS_ranking: "Classement des articles",
    NEWSLETTERS_colArticle: "Article",
    NEWSLETTERS_colTimesSent: "Envois",
    NEWSLETTERS_colReached: "Contacts touchés",
    NEWSLETTERS_colClicks: "Clics",
    NEWSLETTERS_status_scheduled: "Parti",
    NEWSLETTERS_status_skipped_no_article: "Sauté : aucun contenu",
    NEWSLETTERS_status_skipped_no_recipient: "Sauté : aucun destinataire",
    NEWSLETTERS_status_skipped_no_sender: "Sauté : pas d'expéditeur",
    NEWSLETTERS_status_failed: "En échec",

    NEWSLETTERS_error_no_dynamic_block: "L'e-mail ne contient aucun bloc rempli à l'envoi (articles, annonces ou annonces vendues) : la newsletter ne peut pas être activée.",
    NEWSLETTERS_error_newsletter_not_found: "Newsletter introuvable pour ce client.",
    NEWSLETTERS_error_contact_not_found: "Ce contact n'appartient pas à ce client.",
    NEWSLETTERS_error_newsletter_without_sender: "Renseignez l'adresse de l'expéditeur avant l'essai.",
    NEWSLETTERS_error_no_article: "Ce contact ne recevrait aucun contenu au prochain envoi : l'essai ne part pas.",
    NEWSLETTERS_error_invalid_newsletter: "Un champ n'est pas valide.",
    NEWSLETTERS_error_invalid_search: "La sélection des destinataires n'est pas valide.",
    NEWSLETTERS_error_route_not_allowed: "Appel refusé par la Console.",
    NEWSLETTERS_error_image_required: "Aucun fichier reçu : choisissez une image.",
    NEWSLETTERS_error_image_invalid: "Ce fichier n'est pas une image.",
    NEWSLETTERS_error_name_required: "Donnez un nom à l'image.",
    NEWSLETTERS_error_name_too_long: "Le nom de l'image dépasse 200 caractères.",
    NEWSLETTERS_error_public_media_not_found: "Cette image n'appartient pas à ce client.",
    NEWSLETTERS_error_group_without_user:
        "Ce client n'a aucun utilisateur : l'image ne peut pas être rangée à son nom.",

    NEWSLETTERS_enableForCustomer: "Activer pour un client",
    NEWSLETTERS_filter_enabled: "Activée",
    NEWSLETTERS_filter_disabled: "Désactivée",
    NEWSLETTERS_filter_all: "Toutes",
    NEWSLETTERS_noOffer: "Aucun client dans cette liste.",
    NEWSLETTERS_colCustomer: "Client",
    NEWSLETTERS_colOffer: "Offre",
    NEWSLETTERS_colNewsletters: "Newsletters",
    NEWSLETTERS_colActive: "Actives",
    NEWSLETTERS_colNewsletter: "Newsletter",
    NEWSLETTERS_colOn: "Statut",
    NEWSLETTERS_colEnabledBy: "Modifiée le / par",
    NEWSLETTERS_stateOn: "Activée",
    NEWSLETTERS_stateOff: "Désactivée",
    NEWSLETTERS_offersPending: "La liste des clients qui ont l'offre attend une route de l'API (demandée à Guillaume le 21/10). En attendant, cherchez le client.",
    NEWSLETTERS_relayMissing: "Le serveur de la Console n'a pas encore la newsletter automatique : il faut déployer le back de la Console (branche hotfix28) sur staging. En attendant, ni la liste ni l'activation ne peuvent fonctionner ; la recherche des clients, si.",
    NEWSLETTERS_cadenceMonthly: "Chaque mois",
    NEWSLETTERS_cadenceMonthlyN: "Tous les {every} mois",
    NEWSLETTERS_cadenceWeekly: "Chaque semaine",
    NEWSLETTERS_cadenceWeeklyN: "Toutes les {every} semaines",
    NEWSLETTERS_contactSearchHint: "Tapez au moins deux lettres du nom ou de l'e-mail.",
    NEWSLETTERS_copyVariable: "Copier",
    NEWSLETTERS_emailInvalid: "Adresse e-mail invalide.",
    NEWSLETTERS_excludeContacts: "Ne pas envoyer à ces contacts",
    NEWSLETTERS_excludeTags: "Ne pas envoyer aux contacts portant les tags",
    NEWSLETTERS_explainAllCovers: "(« Tous les contacts » inclut déjà les autres critères cochés)",
    NEWSLETTERS_explainBounced: "{count} adresses en échec",
    NEWSLETTERS_explainContacts: "{count} contacts choisis un par un",
    NEWSLETTERS_explainExcluded: "écartés : {details}",
    NEWSLETTERS_explainNoEmail: "{count} sans adresse e-mail",
    NEWSLETTERS_explainNotAuthorized: "{count} consentement refusé (RGPD)",
    NEWSLETTERS_explainOr: " ou ",
    NEWSLETTERS_explainRemoved: "retirés par « Ne pas envoyer » : {criteria}",
    NEWSLETTERS_explainRetained: "contacts : {criteria}",
    NEWSLETTERS_explainRule: "Un contact retiré par « Ne pas envoyer » ne reçoit jamais la newsletter, même s'il répond à un autre critère coché.",
    NEWSLETTERS_explainTags: "contacts portant {tags}",
    NEWSLETTERS_explainTitle: "Comment ce chiffre est obtenu :",
    NEWSLETTERS_fieldCadence: "Fréquence",
    NEWSLETTERS_fieldFirstWeekday: "Le premier",
    NEWSLETTERS_fieldRequired: "Obligatoire pour que la newsletter parte.",
    NEWSLETTERS_fieldTime: "À",
    NEWSLETTERS_fieldWeekday: "Le",
    NEWSLETTERS_noResult: "Aucun résultat.",
    NEWSLETTERS_recipientsRequired: "Cochez au moins un critère de destinataires.",
    NEWSLETTERS_saveAndCreate: "Enregistrer et créer la newsletter",
    NEWSLETTERS_searchTag: "Rechercher un tag",
    NEWSLETTERS_searchVariable: "Rechercher une variable",
    NEWSLETTERS_variables: "Variables",
    NEWSLETTERS_variablesLegal: "Contact (société)",
    NEWSLETTERS_variablesNatural: "Contact (personne)",
    NEWSLETTERS_variablesOwner: "Conseiller du contact",
    NEWSLETTERS_variablesDate: "Date de l'envoi",
    NEWSLETTERS_dateDay: "Jour",
    NEWSLETTERS_dateMonth: "Mois",
    NEWSLETTERS_dateMonthYear: "Mois et année",
    NEWSLETTERS_dateYear: "Année",
    NEWSLETTERS_groupTags: "Tags",
    NEWSLETTERS_groupContacts: "Contacts",
    NEWSLETTERS_sendTo: "Envoyer à",
    NEWSLETTERS_sendToHelp: "Un contact reçoit la newsletter s'il répond à au moins un de ces critères.",
    NEWSLETTERS_doNotSendTo: "Ne pas envoyer à",
    NEWSLETTERS_doNotSendToHelp: "Retirés même s'ils répondent à un critère « Envoyer à ».",
    NEWSLETTERS_tagsWith: "Contacts portant ces tags",
    NEWSLETTERS_contactsOneByOne: "Contacts choisis un par un",
    NEWSLETTERS_bubbleTitle: "Quel article amène le plus d'activité",
    NEWSLETTERS_bubbleNote: "Une bulle par article envoyé sur la période : en largeur, les contacts qui ont ouvert un e-mail où il figurait ; en hauteur, la part de ces lecteurs qui a cliqué pour le lire. Cliquez sur une bulle pour ouvrir l'article.",
    NEWSLETTERS_bubbleX: "Ouvertures",
    NEWSLETTERS_bubbleY: "Taux de clic des lecteurs",
    NEWSLETTERS_bubbleSize: "taille = visites du blog",
    NEWSLETTERS_stageLabel: "Étape",
    NEWSLETTERS_stageAll: "Tous",
    NEWSLETTERS_stageTop: "Haut de tunnel",
    NEWSLETTERS_stageMiddle: "Milieu de tunnel",
    NEWSLETTERS_stageBottom: "Bas de tunnel",
    NEWSLETTERS_stageNone: "Sans étape",
    NEWSLETTERS_stageHint: "L'étape se lit sur le tag TOFU, MOFU ou BOFU posé sur l'article.",
    NEWSLETTERS_stageMissing: "Aucun article n'a encore de tag TOFU, MOFU ou BOFU : toutes les bulles sont « Sans étape ».",
    NEWSLETTERS_colStage: "Étape",
    NEWSLETTERS_bubbleClicks: "{count} clics ({rate} des lecteurs)",
    NEWSLETTERS_bubbleVisits: "{count} visites du blog",
    NEWSLETTERS_bubbleOpen: "Cliquez pour ouvrir l'article",
    NEWSLETTERS_bubbleOpened: "{count} ouvertures",
    NEWSLETTERS_bubblePosition: "Place moyenne dans l'e-mail : {position}",
    NEWSLETTERS_bubbleFew: "Moins de {count} ouvertures : trop peu pour conclure",
    NEWSLETTERS_bubbleCaveat: "Les ouvertures sont approchées (images bloquées, ouvertures automatiques d'Apple Mail) : le taux sert à comparer les articles entre eux. Une bulle pâle a moins de 20 ouvertures.",
    NEWSLETTERS_bubbleWaiting: "Pas encore d'ouverture par article sur la période. Les bulles apparaissent avec les premières ouvertures.",
    NEWSLETTERS_demoHypothesis:
        "Hypothèse : 3 000 contacts éligibles, une newsletter toutes les deux semaines pendant six mois (13 envois, dont un sauté faute d'article), 6 articles par envoi soit 12 par mois (72 articles), 20 % d'ouverture en moyenne. Articles : 50 % TOFU, 30 % MOFU, 20 % BOFU.",
    NEWSLETTERS_sinceFirstSend: "Depuis le premier envoi",
    NEWSLETTERS_periodRange: "{from} à {to}",
    NEWSLETTERS_periodThisWeek: "Cette semaine",
    NEWSLETTERS_periodLastWeek: "La semaine dernière",
    NEWSLETTERS_periodThisMonth: "Ce mois-ci",
    NEWSLETTERS_periodLastMonth: "Le mois dernier",
    NEWSLETTERS_periodLast3Months: "Les 3 derniers mois",
    NEWSLETTERS_periodLast6Months: "Les 6 derniers mois",
    NEWSLETTERS_periodThisYear: "Cette année",
    NEWSLETTERS_periodLastYear: "L'année dernière",
    NEWSLETTERS_overviewTitle: "Performances",
    NEWSLETTERS_overviewSubtitle: "Ce que la newsletter a produit sur la période.",
    NEWSLETTERS_quick3m: "3 mois",
    NEWSLETTERS_quick6m: "6 mois",
    NEWSLETTERS_quick1y: "1 an",
    NEWSLETTERS_quickAll: "Tout",
    NEWSLETTERS_quickCustom: "Personnalisé",
    NEWSLETTERS_funnelTitle: "Du destinataire au lecteur",
    NEWSLETTERS_funnelSubtitle: "E-mails envoyés → délivrés → ouverts → cliqués → visites du blog",
    NEWSLETTERS_funnelSent: "Envoyés",
    NEWSLETTERS_funnelDelivered: "Délivrés",
    NEWSLETTERS_funnelOpened: "Ouverts",
    NEWSLETTERS_funnelClicked: "Cliqués",
    NEWSLETTERS_funnelVisits: "Visites du blog",
    NEWSLETTERS_funnelStart: "point de départ",
    NEWSLETTERS_funnelOfSent: "des envoyés",
    NEWSLETTERS_funnelOfDelivered: "des délivrés",
    NEWSLETTERS_funnelOfOpened: "des ouverts",
    NEWSLETTERS_funnelOfClicked: "des cliqués",
    NEWSLETTERS_funnelSoon: "Bientôt disponible",
    NEWSLETTERS_funnelNote: "Hauteurs adoucies pour que les petites étapes restent lisibles ; les nombres sont exacts. Les ouvertures sont sous-comptées (pixel de suivi).",
    NEWSLETTERS_funnelUnitEmails: "e-mails",
    NEWSLETTERS_funnelUnitContacts: "contacts",
    NEWSLETTERS_funnelUnitVisits: "visites",
    NEWSLETTERS_sendsSkippedOne: "{count} envoi sauté faute de contenu",
    NEWSLETTERS_spamOne: "{count} plainte",
    NEWSLETTERS_sendsSubtitle: "Un clic sur une ligne : ses contacts et ses articles.",
    NEWSLETTERS_rankingSubtitle: "Les plus cliqués d'abord. Un clic sur le titre ouvre l'article.",
    NEWSLETTERS_colOpenedPost: "Ouvertures",
    NEWSLETTERS_colCtor: "Taux de clic des lecteurs"
};
